<template>
  <div>
    <!-- <meta name="viewport" content="width=device-width,initial-scale=1.0" /> -->
    <sub-head subTitle="제품 소개" subImg="product_top" class="web"></sub-head>
    <div class="page_padding">
      <bread-crumb :path="$route" class="bread"></bread-crumb>
    </div>

    <div class="main-page">
      <div class="summary" style="padding-top: 90px">
        <h2 v-html="summary.h"></h2>
        <p style="margin-top: 40px" v-html="summary.p"></p>
        <image-component
          style="padding-top: 90px; padding-top: 100px;"
          path="product43/table43_01.png"
        ></image-component>
      </div>

      <div class="solution-program" style="padding-top: 162px">
        <h1 v-html="solution.h"></h1>
        <p style="margin-top: 40px" v-html="solution.p"></p>
        <div style="margin-top: 80px;"></div>
        <div class="flex">
          <div
            v-for="(obj, index) in solutionList"
            :key="index + obj.title"
            style="max-width: 570px;"
          >
            <image-component :path="obj.imgPath"></image-component>
            <h4 style="margin-top: 30px; text-align: left;">
              {{ obj.title }}
            </h4>
            <p style="margin-top: 20px; text-align: left;">
              {{ obj.content }}
            </p>
          </div>
        </div>
        <div style="padding-top: 187px;"></div>
      </div>

      <div class="data-collection" style="margin-top: 160px">
        <h1 v-html="collection.h"></h1>
        <p
          style="margin-top: 62px; text-align: left;"
          v-html="collection.p"
        ></p>
        <div class="flex" style="margin-top: 110px">
          <div
            v-for="(obj, index) in dataCollectionList"
            :key="index + obj.title"
            style="width: 320px"
          >
            <image-component
              class="circle-bg"
              :path="obj.imgPath"
            ></image-component>
            <h4 style="margin-top: 30px">{{ obj.title }}</h4>
            <p style="margin-top: 20px; max-width: 300px;">{{ obj.content }}</p>
          </div>
        </div>
        <div style="margin-top: 100px;" />
      </div>
      <div class="divider" style="background: none;"><hr /></div>
      <div class="spec" style="margin-top: 155px;">
        <h1 v-html="spec.h"></h1>
        <h5 v-html="spec.p"></h5>
        <div class="flex" style="margin-top: 163px">
          <image-component
            path="product43/table43_02.png"
            style="flex-grow: 2;"
          ></image-component>
          <table style="margin: auto;">
            <tr v-for="(value, key) in specList" :key="key + value">
              <th>{{ key }}</th>
              <td>{{ value }}</td>
            </tr>
          </table>
        </div>
        <div style="padding-top: 210px;"></div>
      </div>
    </div>
  </div>
</template>

<script>
import ImageComponent from "@/components/imageComponent.vue";
import subHead from "@/components/sub_head.vue";
import BreadCrumb from "@/components/BreadCrumb.vue";

// import Tab from "@/components/Tab.vue";
export default {
  components: {subHead, ImageComponent, BreadCrumb},

  data() {
    return {
      summary: {
        h:
          '시니어 여가활동 증진 및 인지능력 향상 목적인<br />조달청 나라장터 등록 <b>"스마트 터치 테이블"</b>',
        p:
          "사용자 데이터 기반으로 경도인지 장애를 선별하고, 지속적인 추적관리가 가능한 시스템",
      },
      solution: {
        h: "해피테이블 솔루션 프로그램",
        p: "최고의 인지능력 향상 프로그램으로 치매 예방에도 기여합니다.",
      },
      solutionList: [
        {
          title: "멀티 터치 디스플레이",
          content: `게임에 적합하고 4인 동시 플레이가 가능한 스마트 테이블\n동시에 30회의 입력이 가능한 멀티 터치 디스플레이 모니터 및 내부 PC 발열을 고려한 쿨링 디자인`,
          imgPath: "product43/product43_img01.png",
        },
        {
          title: "사용성 & 효과성 평가완료",
          content:
            "해피테이블이 시니어들의 인지향상에 도움된다라는 내용의 사용성과 효과성 평가 완료",
          imgPath: "product43/product43_img02.png",
        },
        {
          title: "CMS 통합 관리 사이트 제공",
          content:
            "회원별 상세데이터, 게임별 상세 데이터, 날짜별 상세 데이터 제공",
          imgPath: "product43/product43_img03.png",
        },
        {
          title: "그 외 다양한 콘텐츠",
          content:
            "치매 예방 체조, 레크레이션, 간이정신상태 검사 등 콘텐츠 탑재\n\
            다양한 콘텐츠를 지속적으로 업데이트",
          imgPath: "product43/product43_img04.png",
        },
      ],
      collection: {
        h: "기능성 게임 활동 및 데이터 관리",
        p:
          "해피 테이블을 통해 진행하는 모든 인지 활동 프로그램에 대한 데이터를 수집합니다.\
          이러한 데이터는 해피 테이블만의 알고리즘을 통하여 반응력, 기억력, 문제 해결력,\
          주의력, 유연성, 수리력에 대한 인지 기능 측정 및 치매에 관련한 위험도를 분석하고 경고합니다.",
      },
      dataCollectionList: [
        {
          title: "인지 강화를 위한 게임",
          content:
            "해피테이블은 정확한 데이터의 제공을 위해 필요한 최소한의 개인 정보를 수집하고 있습니다.",
          imgPath: "product43/ic_happytable_no1.png",
        },
        {
          title: "실제 사용자의 플레이",
          content: "해피테이블의 게임 콘텐츠를 즐겨보세요.",
          imgPath: "product43/ic_happytable_no2.png",
        },
        {
          title: "플레이 데이터의 저장",
          content: "사용자 분들의 게임 플레이 데이터를 안전하게 기록합니다.",
          imgPath: "product43/ic_happytable_no3.png",
        },
        {
          title: "데이터 관리",
          content:
            "다양한 이해 관계자 분들께 데이터를 제공하기 위해 해피테이블의 알고리즘을 통하여 관리됩니다.",
          imgPath: "product43/ic_happytable_no4.png",
        },
        {
          title: "CMS에서 확인",
          content:
            "이러한 데이터들은 해피테이블에서 제공하는 CMS에서 확인합니다.",
          imgPath: "product43/ic_happytable_no5.png",
        },
        {
          title: "데이터의 활용",
          content:
            "실제 사용자 분들에겐 분석 결과에 대한 안내를, 의료진 및 전문가 분들에게는 데이터 사용의 편의성과 효율성을 제공합니다.",
          imgPath: "product43/ic_happytable_no6.png",
        },
      ],
      spec: {
        h: "43인치 키오스크형 해피테이블",
        p: "(happytable 43inch kiosk type)",
      },
      specList: {
        제품명: "해피테이블 43인치 키오스크",
        모델명: "HT43A",
        "제품 규격": "1344(W)x932(D)x750(H)mm",
        중량: "128kg",
        "전원 및 소비전력": "220V / 75W",
        멀티터치: "40포인트",
        스피커출력: "8W",
        "상판 유리두께": "95mm",
        운영체제: "윈도우",
      },
    };
  },
};
</script>

<style scoped>
h1,
h2,
h3,
h4,
h5,
h6 {
  word-break: keep-all;
  word-wrap: break-word;
}
h1 {
  font-size: 2.5rem;
  font-weight: 800;
  line-height: 3.75rem;
  color: #0a0a0a;
}

h2 {
  font-size: 2.125rem;
  font-weight: bold;
  line-height: 3.75rem;
  letter-spacing: -0.064rem;
  color: #878282;
}

h4 {
  font-size: 1.375rem;
  line-height: 2.75rem;
  font-weight: 800;
  color: #1c1c1c;
}

h5 {
  font-size: 1.25rem;
  line-height: 2.75rem;
  font-weight: 800;
  color: #1c1c1c;
}

.main-page ::v-deep b {
  color: #ff5230;
}

p {
  font-size: 1.125rem;
  font-weight: 500;
  color: #5a5a5a;
  line-height: 2.375rem;
  word-break: keep-all;
  word-wrap: break-word;
  white-space: pre-line;
}

hr {
  border: 1px solid #0a0a0a;
}

table {
  border-collapse: collapse;
}

th,
td {
  border-top: 1px solid #707070;
  border-bottom: 1px solid #707070;
  padding: 18px 20px;
}

td {
  color: #5a5a5a;
  text-align: left;
}

th {
  background-color: #f6f6f6;
  color: #1c1c1c;
}

/* TODO: because of mulfunction of image width v-deep is used, need to fix. */
::v-deep img {
  width: unset !important;
  max-width: 100%;
}

.main-page > div > * {
  max-width: 1200px;
  margin: auto;
  padding: 0 20px;
}

.main-page > div:nth-child(even) {
  background-color: #f7f9fb;
}

/* .main-page > div:nth-child(odd) {} */

.flex {
  display: flex;
  flex-wrap: wrap;
  gap: 60px 30px;
}

.flex > * {
  flex: 1 1 auto;
  margin: 0 auto;
}

.flex p {
  font-size: 0.875rem;
  line-height: 1.5rem;
  margin: auto;
}

.spec {
  background: none !important;
}

.circle-bg {
  background: #f6f6f6;
  border-radius: 50%;
  width: 180px;
  height: 180px;
  margin: auto;
  padding: 39px;
  box-sizing: border-box;
}
@media (max-width: 767px) {
  .banner.web {
    margin-top: 60px;
    .banner-title {
      font-size: 1.52rem;
    }
  }

  h1 {
    font-size: 1.5rem;
    line-height: 2rem;
  }
  h2 {
    font-size: 1.4rem;
    line-height: 1.8rem;
  }
}
</style>
